import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { QueryFilter } from './search/QueryFilter';
import analytics from '../../modules/analytics';
import { useIsMobileOrDesktopNarrow, useIsMobile } from '../../hooks';
import { toSlugCase } from '../../modules/stringUtils';
import { SEARCH_ROUTE } from '../../route-names';

import './NavSearchBar.module.scss';

const SEARCH_SOURCE_DESKTOP = 'search_bar';

/**
 * Renders the search section for the nav bar.
 * @example
 * import NavSearchBar from 'components/consumer/NavSearchBar';
 *
 * const MyComponent = () => {
 *   return (
 *     <NavSearchBar />
 *   );
 * }
 */
export const NavSearchBarPure = ({
  address,
  query,
  date,
  linkTo,
  isLandingRedesignEnabled,
}) => {
  const isMobileDeprecated = useIsMobile();
  const isMobileRedesign = useIsMobileOrDesktopNarrow();

  const isMobile = isLandingRedesignEnabled ? isMobileRedesign : isMobileDeprecated;

  const setQuery = newQuery => {
    linkTo(SEARCH_ROUTE, {
      q: toSlugCase(newQuery),
      loc: toSlugCase(address),
      date,
      source: SEARCH_SOURCE_DESKTOP,
    });
  };

  const onClosePopover = () => {
    analytics.track(
      'client_search_popover_closed',
      { is_mobile: false },
    );
  };

  if (isMobile) {
    return null;
  }

  return (
    <View
      styleName="nav-search-bar-component"
    >
      <QueryFilter
        query={query || ''}
        setQuery={setQuery}
        onClosePopover={onClosePopover}
        showSearchButton
        showIcon
        appearance="rounded"
      />
    </View>
  );
};

NavSearchBarPure.propTypes = {
  address: PropTypes.string,
  date: PropTypes.string,
  query: PropTypes.string,
  /** Pass route and params for navigation */
  linkTo: PropTypes.func.isRequired,
  isLandingRedesignEnabled: PropTypes.bool,
};

NavSearchBarPure.defaultProps = {
  address: '',
  date: null,
  isLandingRedesignEnabled: false,
  query: '',
};

const mapStateToProps = ({ search }) => ({
  date: search.date,
  query: search.query,
  address: search.address,
});

const mapDispatchToProps = dispatch => ({
  linkTo: (route, params, notify = true) => dispatch.route.go({
    route, params, notify,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavSearchBarPure);
